import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#0597A3" d="M24.03 48.16a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="m104.87 48.16 3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM106.25 72.1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M16.64 55.07h-5.57V49.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H2.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M10.07 88c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M55.56 47.51v12.25c0 1.34 1.62 2.02 2.57 1.07l14.38-14.38c.28-.28.67-.44 1.07-.44h15.26c.83 0 1.51-.67 1.51-1.51V12.72c0-.83-.68-1.51-1.51-1.51H45.46c-.83 0-1.51.67-1.51 1.51V44.5c0 .83.67 1.51 1.51 1.51h8.58c.83 0 1.51.67 1.51 1.51z"
    />
    <path
      fill="#001A43"
      d="M78.75 25.06h-23.2c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h23.2c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M78.75 36.66h-23.2c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h23.2c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25"
    />
    <path
      fill="#00D8D8"
      d="M38.08 78.92c5.7 0 10.32-4.62 10.32-10.32s-4.62-10.32-10.32-10.32S27.76 62.9 27.76 68.6s4.62 10.32 10.32 10.32M23.19 90.15a.846.846 0 0 1-.76-1.22c2.74-5.91 8.72-10.01 15.65-10.01s12.42 4.37 15.3 9.97c.29.57-.1 1.25-.75 1.25H23.19z"
    />
    <path
      fill="#0597A3"
      d="M78.92 78.92c5.7 0 10.32-4.62 10.32-10.32s-4.62-10.32-10.32-10.32S68.6 62.9 68.6 68.6s4.62 10.32 10.32 10.32M64.03 90.15a.846.846 0 0 1-.76-1.22c2.74-5.91 8.72-10.01 15.65-10.01s12.42 4.37 15.3 9.97c.29.57-.1 1.25-.75 1.25H64.03z"
    />
  </svg>
);
const SvgEnrichedIconCollaborateInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconCollaborateInverted);
export default Memo;
